/*
 * @Description: 预约排号 排号管理
 * @Author: ma.cq
 * @Date: 2018-10-18 10:41:53
 * @LastEditors: ma.cq
 * @LastEditTime: 2018-10-23 20:50:51
 */
<template>
  <div class="appoint-number-manager">
    <el-row class="title">放号范围</el-row>
    <el-form>
      <el-row>
        <el-col :span="8">
          <el-form-item label="提货区域">
            {{current.deliveryArea}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品大类">
            {{current.itemLarge}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品中类">
            {{current.itemMiddle}}
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="涉及商品">
            {{current.itemInfo.join('、')}}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="title">通用模板</el-row>
    <el-row>
      <span class="noTempTip" v-show="!isSetMould">您还未配置模板</span>
      <el-button type="primary" @click="setTemp(!isSetMould ? '' : $route.query.id, isSetMould, 0)">配置模板</el-button>
    </el-row>
    <el-row class="title">放号情况</el-row>
    <full-calendar :events="fcEvents" @changeMonth="changeMonth" locale="zh-cn"></full-calendar>
    <set-or-reset-dialog v-on:childByValue="childByValue" :show.sync="setOrResetDialogShow" :id="curId" :isUpdate="isUpdate" :info="info"/>
    <check-dialog :show.sync="checkDialogShow" :id="curId" :listInfo="listInfo"/>
  </div>
</template>
<script>
import fullCalendar from '@/components/fullCalendar'
import SetOrResetDialog from './setOrResetDialog'
import CheckDialog from './checkDialog'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'appointNumberManager',
  components: { fullCalendar, SetOrResetDialog, CheckDialog },
  data () {
    return {
      pickerValue: new Date(),
      fcEvents: [],
      setOrResetDialogShow: false,
      checkDialogShow: false,
      month: '',
      curId: '',
      listInfo: {},
      isSetMould: true,
      list: [],
      isUpdate: false,
      info: {
        month: '',
        poolID: '',
        isTem: false,
        isNum: 0
      }
    }
  },
  methods: {
    ...mapActions(['appointNumMouldList']),
    setTemp (id, bol, num) {
      if (id) {
        this.curId = id
        this.info.isTem = true
      } else {
        this.curId = ''
      }
      this.info.isNum = num
      this.isUpdate = bol
      this.setOrResetDialogShow = true
    },
    checkTemp (list) {
      this.curId = list.id
      this.listInfo = list
      this.checkDialogShow = true
    },
    childByValue (res) {
      this.isSetMould = Boolean(res.list.length)
      let arr = []
      if (res.list.length > 0) {
        this.list = res.list
        res.list.forEach(list => {
          /*
          * 0 -- 实际到场
          * 1 -- 线下认证
          * 2 -- 已预约
          * 3 -- 查看详情
          * 4 -- 已排号
          * 5 -- 重新排号
          * */
          let today = new Date(res.today).getTime()
          let date = new Date(list.date).getTime()
          let num = (date - today) / 86400000
          let typeArr = []
          let isBefore = false
          if (num < 0) { // 今天以前
            typeArr = [0, 1, 2]
            isBefore = true
          } else if (num < 3) {
            typeArr = [0, 1, 2, 3]
            isBefore = false
          } else {
            typeArr = [4, 5]
            isBefore = false
          }
          typeArr.forEach(item => {
            let obj = {}
            switch (item) {
              case 0 :
                obj.title = `实际到场：${list.orderPresentCount}人`
                obj.start = list.date
                obj.end = list.date
                if (isBefore) obj.cssClass = ['pastText']
                break
              case 1 :
                obj.title = `线下认证：${list.unlineAuthCount}人`
                obj.start = list.date
                obj.end = list.date
                if (isBefore) obj.cssClass = ['pastText']
                break
              case 2 :
                obj.title = `已预约：${list.orderCount}人`
                obj.start = list.date
                obj.end = list.date
                if (isBefore) obj.cssClass = ['pastText']
                break
              case 3 :
                obj.btnTitle = `重新排号`
                obj.start = list.date
                obj.end = list.date
                obj.btnFun = () => {
                  this.checkTemp(list)
                }
                break
              case 4 :
                obj.title = `已排号`
                obj.start = list.date
                obj.end = list.date
                obj.cssClass = ['already']
                break
              case 5 :
                obj.btnTitle = `重新排号`
                obj.start = list.date
                obj.end = list.date
                obj.btnType = 'primary'
                obj.btnFun = () => {
                  this.setTemp(list.id, true, 1)
                }
                break
            }
            arr.push(obj)
          })
        })
      } else {
        arr = [{
          btnTitle: '设置模板',
          start: res.today,
          end: res.today,
          btnType: 'primary',
          btnFun: () => {
            this.setTemp('', false, 0)
          }
        }]
      }
      this.fcEvents = arr
    },
    changeMonth (start, end, s, a) {
      s && this.appointNumMouldList({ month: s.format('YYYY-MM'), poolID: this.$route.query.id }).then(res => {
        this.info = {
          month: s.format('YYYY-MM'),
          poolID: this.$route.query.id
        }
        this.childByValue(res)
      })
    }
  },
  mounted () {
    this.changeMonth()
  },
  computed: {
    ...mapGetters({
      current: 'getPickCurrentAppoint'
    })
  }
}
</script>
<style lang="scss" scoped>
.title{
  font-size: 18px;
  margin: 10px 0;
}
.noTempTip{
  line-height: 17px;
  margin-right: 10px;
}
/deep/ .pastText{
  color: #ccc;
}
/deep/ .already{
  height: 54px;
  line-height: 54px;
}
/deep/ .verticalCenter{
  height: 54px;
  line-height: 54px;
}
</style>
